import { useAppDispatch, useAppSelector } from '../../state/hooks'
import { setOnboardingVisible } from '../../state/slices/onboardingSlice'
import { NEW_COMPANY_CTA_ENABLED } from '../../config/featureGates'
import { showCurrentlyDisabledToast } from '../../utils/toastApi'
import './SampleBanner.css'

export default function SampleBanner() {
  const dispatch = useAppDispatch()
  const active = useAppSelector((s: any) => {
    const id = s.companies.activeCompanyId
    return s.companies.companies.find((c: any) => c.id === id)
  })
  if (!active?.isSample) return null

  const handleClick = () => {
    if (NEW_COMPANY_CTA_ENABLED) {
      dispatch(setOnboardingVisible(true))
    } else {
      showCurrentlyDisabledToast()
    }
  }

  return (
    <div className="sample-banner" role="banner">
      <span>You're viewing the Sample Company. Explore any tab — then create your own company when you're ready.</span>
      <button
        className={NEW_COMPANY_CTA_ENABLED ? '' : 'cta-disabled'}
        aria-disabled={!NEW_COMPANY_CTA_ENABLED}
        onClick={handleClick}
      >
        Create Your Company →
      </button>
    </div>
  )
}
